import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import constants from '../../mobile/commons/MobileFormsConstants';

const pulseKeyFrame = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4); }
  70% { box-shadow: 0 0 0 10px rgba(204, 169, 44, 0); }
  100% { box-shadow: 0 0 0 0 rgba(204, 169, 44, 0); }
`;

const IconBadgeContainer = styled.div`
  position: relative;
  background-color: red;
  font-size: 13px;
  font-weight: bolder;
  color: #FFF;
  margin-top: -40px;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  cursor: pointer;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Apply animation only when visible */
  animation: ${pulseKeyFrame} 2s infinite;

  &:hover {
    animation: none;
  }
`;

const MobileDeviceIconBadge = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <IconBadgeContainer title="Mobile design requires attention.">
      {constants.ICON_PULSE || '!'}
    </IconBadgeContainer>
  );
};

export default MobileDeviceIconBadge;